import { fetchSiteClassification } from '../api/fetchSiteClassification';
import {
  setCachedClassification,
  getCachedClassification,
} from '../storage/classificationLRU';

const IPV4_OCTET_PATTERN = String.raw`(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)`;
const IPV4_HOSTNAME_PATTERN = new RegExp(
  String.raw`^${IPV4_OCTET_PATTERN}(\.${IPV4_OCTET_PATTERN}){3}$`
);

export const isClassifiableHostname = (hostname: string): boolean => {
  const normalizedHostname = hostname.trim().toLowerCase();

  return (
    normalizedHostname !== '' &&
    normalizedHostname.includes('.') &&
    !IPV4_HOSTNAME_PATTERN.test(normalizedHostname) &&
    !normalizedHostname.includes(':')
  );
};

export const getClassification = async (hostname: string) => {
  if (!isClassifiableHostname(hostname)) {
    return undefined;
  }

  const cachedClassification = getCachedClassification(hostname);
  if (cachedClassification) {
    return cachedClassification;
  }

  const apiClassification = await fetchSiteClassification(hostname);
  if (apiClassification) {
    setCachedClassification(hostname, apiClassification);
  }

  return apiClassification;
};
